module.exports = __webpack_public_path__ + "img/ic_32_workout_low.972bc114.svg";